import {
  CreatePageElementsPayload,
  type PageElementsResponse,
} from "@/interfaces/element.interface";
import { ApiQueryParams, apiRequest } from "../Api";

export interface CreatePageElementsResponse {
  success: boolean;
  message: string;
  data: { id: string };
  execution_time: number;
  cached: boolean;
  timestamp: string;
}

export const createPageElements = (
  params: ApiQueryParams,
  data: CreatePageElementsPayload,
) =>
  apiRequest<{ data: CreatePageElementsPayload }, CreatePageElementsResponse>({
    url: '/entities/create',
    scope: 'page_element',
    method: 'POST',
    params,
    data: { data },
  });
